<template>
  <div>
    <nav>
      <ul class="pager">
        <li class="previous">
          <router-link :to="{name: 'client_reports', client_id: $route.params.client_id}">
            <span aria-hidden="true">&larr;</span> Reports
          </router-link>
        </li>
      </ul>
    </nav>
    <template v-if="!selected.id">
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <h2>
            Select a Client Farm
          </h2>


          <div class="panel-body">
            <div class="form-group">
              <v-select label="farm_name"
                        :filterable="true"
                        :clearable="false"
                        :options="farms"
                        v-model="selected">

                <template slot="option" slot-scope="option">
                  {{currentClient.display_name}} - {{ option.farm_name }}
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <select-report-type :farm-id="selected.id" :display-name="`${currentClient.display_name} - ${selected.farm_name}`" @reset-farm="onResetFarm">
      </select-report-type>
    </template>
  </div>
</template>
<script>
import SelectReportType from '@/components/reports/vadrug/SelectReportType.vue'
import vSelect from 'vue-select'
import { mapState, mapActions } from 'vuex'


export default {
  name: 'VaDrugReportPage',
  components: {
    vSelect,
    SelectReportType,
  },
  data() {
    return {
      selected: {
        id: null,
        farm_name: ''
      }
    }
  },
  mounted(){
    if (!this.currentClient)
    {
      this.getClient(this.$route.params.client_id)
    }
  },
  computed: {
    ...mapState('client', ['currentClient']),
    farms: function ()
    {
      return this.currentClient ? this.currentClient.farm_set : []
    }
  },
  methods: {
    ...mapActions('client', ['getClient']),
    onResetFarm: function ()
    {
      this.selected = {}
    }
  },
};
</script>
